module.exports = __webpack_public_path__ + "img/swiper_01.01597ac1.jpg";